import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { Button } from '../button/index.js';
import { Form } from '../form/index.js';
import { IconTarget } from '../icons/generated/Target.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Input, Label } from '../form/formstyles.js';
import { BUTTON_VARIANTS } from '../button/constants.js';

var _templateObject, _templateObject2, _templateObject3;
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "searchForm__Wrapper",
  componentId: "sc-ghbzlq-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.accents.muted;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.radii.default;
}, _ref3 => {
  let {
    inputFocused,
    theme
  } = _ref3;
  return inputFocused && "0 0 0 2px ".concat(theme.colors.primary.main);
});
const SearchInput = /*#__PURE__*/styled(Input).withConfig({
  displayName: "searchForm__SearchInput",
  componentId: "sc-ghbzlq-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: none;\n  background: transparent;\n  box-shadow: none;\n\n  &:focus-visible {\n    box-shadow: none;\n  }\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing.baseSpacing;
});
const SearchButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "searchForm__SearchButton",
  componentId: "sc-ghbzlq-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  order: 1;\n  margin-inline-start: ", ";\n  margin-inline-end: ", ";\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing.halfSpacing;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing.baseSpacing;
});
const SearchForm = /*#__PURE__*/forwardRef(function SearchForm(_ref7, ref) {
  let {
    buttonProps,
    buttonText,
    geoLocationButtonProps,
    geoLocationTitleText,
    hideLabel,
    id,
    inputProps,
    label,
    onChange,
    onGeoLocationClick,
    onSubmit,
    placeholder,
    showGeoLocation,
    ...rest
  } = _ref7;
  const [inputFocused, setInputFocused] = useState(false);
  return /*#__PURE__*/jsx(Form, {
    ref: ref,
    onSubmit: onSubmit,
    ...rest,
    children: /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx(Label, {
        htmlFor: id,
        visuallyHide: hideLabel,
        children: label
      }), /*#__PURE__*/jsxs(Wrapper, {
        inputFocused: inputFocused,
        children: [/*#__PURE__*/jsx(SearchInput, {
          id: id,
          name: id,
          onChange: onChange,
          onBlur: () => setInputFocused(false),
          onFocus: () => setInputFocused(true),
          placeholder: placeholder,
          ...inputProps
        }), /*#__PURE__*/jsx(SearchButton, {
          ...buttonProps,
          children: buttonText
        }), showGeoLocation && /*#__PURE__*/jsx(Button, {
          ...geoLocationButtonProps,
          "aria-label": geoLocationTitleText,
          onClick: onGeoLocationClick,
          variant: BUTTON_VARIANTS.PLAIN,
          type: "button",
          children: /*#__PURE__*/jsx(IconTarget, {
            title: geoLocationTitleText,
            style: {
              fontSize: '1.5em'
            }
          })
        })]
      })]
    })
  });
});
SearchForm.defaultProps = {
  onChange: () => {},
  onGeoLocationClick: () => {},
  onSubmit: () => {}
};

export { SearchForm };
